import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const fetchData = createAsyncThunk('api/fetchData', async (apiEndpoint) => {
  const response = await fetch(apiEndpoint);
  const data = await response.json();
  return data;
});

const apiSlice = createSlice({
  name: 'api',
  initialState: {
    data: [],
    status: 'idle',
    error: null,
    fetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.status = 'loading';
        state.fetch = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
        state.fetch = false;
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.fetch = false;
      });
  },
});

export default apiSlice.reducer;
export { fetchData };
